export { Text } from './Text';
export type { TextColor } from './Text';
export type { TextVariant } from './Text';